import { render, staticRenderFns } from "./BasicInfo.vue?vue&type=template&id=7d459cd2&scoped=true"
import script from "./BasicInfo.vue?vue&type=script&lang=js"
export * from "./BasicInfo.vue?vue&type=script&lang=js"
import style0 from "./BasicInfo.vue?vue&type=style&index=0&id=7d459cd2&prod&lang=css"
import style1 from "./BasicInfo.vue?vue&type=style&index=1&id=7d459cd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d459cd2",
  null
  
)

export default component.exports